import ErrorBoundary from 'components/error/ErrorBoundary'
import {NullAsDefault} from "views/Shared";
import _ from 'lodash'
import React from 'react'
import AmChartStateless from '../AmChart/components/AmChartStateless'
import ChartWrapper from '../ChartWrapper/ChartWrapper'

export const TagCloudChartStateless = ({
    header = NullAsDefault,
    item,
    minHeight = 360,
    CWrapper = ChartWrapper,
    ...props
}) => {
  return (
    <ErrorBoundary
      fallbackComponent={() => {
        return (
          <div className="w-full h-full flex justify-center items-center font-bold text-color-300 text-2xl">
            Error
          </div>
        )
      }}>
      <div
        style={{
          minHeight: minHeight,
          height: 0,
        }}
        className="flex-1 flex flex-col">
        <AmChartStateless
          item={item}
          setChartWrap={() => null}
          {...props}
        />
      </div>
    </ErrorBoundary>
  )
}

export const TagCloudChart = ({ minHeight, chartInfo, ...props }) => {
  let item = _.cloneDeep(chartInfo)
  item.chart_source = 'AmChart'
  item.data_encrypted = 0
  item.chart_type = 'WordCloud'
  item.subscribe_required = 0
  item.data_empty = 0
  item.is_static_data = true
  // item.data_values = item.data_values;
  item.version = Date.now()
  item._type = 'chart'
  item.params = props?.params || {}

  return (
    <TagCloudChartStateless
      item={item}
      minHeight={minHeight}
      CWrapper={ChartWrapper}
      {...props}
    />
  )
}

export default React.memo(TagCloudChart)
